const legalNotice = [
  {
    identifier: "terms",
    version: "1"
  },
  {
    identifier: "privacy_policy_customer",
    version: "1"
  }
];

const proofs = [
  {
    form: "signup",
    content: I18n.t("pages.privacy.body_html")
  },
  {
    form: "signup",
    content: I18n.t("tos_html")
  }
];

export async function sendConsentIub(user) {
  if (typeof window._iub.cons_instructions === "undefined") {
    // console.log("is undefined");
    return;
  }

  return new Promise((resolve, reject) => {
    window._iub.cons_instructions.push([
      "submit",
      {
        consent: {
          subject: {
            id: user.id,
            email: user.email,
            first_name: user.firstName,
            last_name: user.lastName
          },
          preferences: {
            terms: user.consents.customer_terms,
            marketing: user.consents.customer_marketing,
            profiling: user.consents.customer_profiling
          },
          legal_notices: legalNotice,
          proofs
        }
      },
      {
        success: res => {
          resolve(res);
        },
        error: err => {
          reject(err);
        }
      }
    ]);
  });
}
